import styled from 'styled-components';

export const GridStyles = styled.div`
  display: grid;
  grid-template-columns: ${({ cols, colsSize }) =>
    `repeat(${cols}, ${colsSize || '1fr'})` || undefined};
  grid-template-rows: ${({ rows, rowsSize }) =>
    `repeat(${rows}, ${rowsSize || 'auto'})` || undefined};
  grid-column-gap: ${({ colsGap }) => colsGap || undefined};
  grid-row-gap: ${({ rowsGap }) => rowsGap || undefined};
`;
